import { gql } from '@apollo/client/core';
import CityFragment from '@/apollo/fragments/City.fragment';
import CompanyFragment from '@/apollo/fragments/Company.fragment';

const PortfolioCurrentUserFragment = gql`
  ${CityFragment}
  ${CompanyFragment}

  fragment PortfolioCurrentUserFragment on CurrentUser {
    id
    avatarUrl
    autoName
    firstname
    lastname
    phone
    publicEmail
    warRoomYearsOfExperience
    hasOptedInToSms
    position
    linkedinSlug
    warRoomJobSearchStatus
    linkedinUrl
    calendarLink
    departmentIds
    productTypeIds
    warRoomIndustryIds
    warRoomCompanyStageIds
    warRoomSalesRoleIds
    warRoomCompanySeriesStageIds
    slug
    company {
      ...CompanyFragment
    }
    city {
      ...CityFragment
    }
    solidClients {
      id
      isPublic
      position
      company {
        id
        name
        logoUrl
        companyPagesSlug
      }
    }
    departments {
      id
      name
    }
    companyStages {
      id
      name
    }
    warRoomSalesRoles {
      id
      name
    }
    industries {
      id
      name
    }
    productTypes {
      id
      name
    }
    companySeriesStages {
      id
      name
      slug
    }
  }
`;

export default PortfolioCurrentUserFragment;
